import {
  MODIFY_ACCESS,
  NEW_ACCESS,
  RequestResponse,
  REVOKE_ACCESS,
} from "@api";
import { Form, Modal } from "@components";
import { Box, Button } from "@material-ui/core";
import React, { useCallback } from "react";
import { RowWrapper } from "../../types";
import { Filters } from "./types";
import { filloutDropdowns } from "./utils";
import { Manager } from "@components/form/state/types";

interface Props {
  requests: RowWrapper<RequestResponse>[];
  open: boolean;
  onCancel: () => void;
  onApply: (filter: any) => void;
  form: Manager<Filters>;
}
type Key = keyof Filters;

export const MyRequestFilters: React.FC<Props> = ({
  requests,
  open,
  onCancel,
  onApply,
  form,
}) => {
  const {
    environments,
    systemNames,
    statuses,
    systemCategories,
    systemTypes,
  } = filloutDropdowns(requests);

  const handleSubmit = useCallback(() => {
    onApply(form.values);
  }, [form.values, onApply]);

  function onChange(name: Key, value: any): void {
    // [TODO] check types
    form.set(Form.target.VALUE, [name, value]);
  }

  return (
    <Modal isOpen={open} title="Search Filter" closeModal={onCancel}>
      <Form>
        <Form.Dropdown
          label="Status"
          onChange={onChange}
          options={[{ label: "No Selection", value: "" }, ...statuses]}
          name="status"
          size={12}
          error={form.errors.status}
          value={form.values.status || ""}
        />
        <Form.Radiogroup
          row
          label="Date Type"
          name="dateType"
          onChange={onChange}
          options={[
            {
              value: "DATE_REQUESTED",
              label: "Date Requested",
            },
            {
              value: "EFFECTIVE_DATE",
              label: "Effective Date",
            },
          ]}
          size={12}
          value={form.values.dateType}
        />
        <Form.Datebox
          error={form.errors.dateFrom}
          label="From"
          name="dateFrom"
          onChange={onChange}
          size={6}
          value={form.values.dateFrom}
        />
        <Form.Datebox
          error={form.errors.dateTo}
          label="To"
          name="dateTo"
          onChange={onChange}
          size={6}
          value={form.values.dateTo}
        />
        <Form.Dropdown
          label="Type of Action"
          onChange={onChange}
          options={[
            { label: "No Selection", value: "" },
            NEW_ACCESS,
            MODIFY_ACCESS,
            REVOKE_ACCESS,
          ]}
          name="typeOfAction"
          size={12}
          error={form.errors.typeOfAction}
          value={form.values.typeOfAction || ""}
        />
        <Form.Dropdown
          label="System Name"
          onChange={onChange}
          options={[{ label: "No Selection", value: "" }, ...systemNames]}
          name="systemName"
          size={12}
          error={form.errors.systemName}
          value={form.values.systemName || ""}
        />
        <Form.Dropdown
          label="Environment"
          onChange={onChange}
          options={[{ label: "No Selection", value: "" }, ...environments]}
          name="environment"
          size={12}
          error={form.errors.environment}
          value={form.values.environment || ""}
        />
        <Form.Dropdown
          label="System Category"
          onChange={onChange}
          options={[{ label: "No Selection", value: "" }, ...systemCategories]}
          name="systemCategory"
          size={12}
          error={form.errors.systemCategory}
          value={form.values.systemCategory || ""}
        />
        <Form.Dropdown
          label="Business Unit"
          onChange={onChange}
          options={[{ label: "No Selection", value: "" }, ...systemTypes]}
          name="systemType"
          size={12}
          error={form.errors.systemType}
          value={form.values.systemType || ""}
        />
      </Form>
      <Box textAlign="right" mt={4}>
        <Button variant="outlined" color="primary" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          type="button"
          onClick={handleSubmit}
          style={{ marginLeft: "40px" }}
        >
          Apply
        </Button>
      </Box>
    </Modal>
  );
};
